module.exports = __webpack_public_path__ + "img/enemy3.dd0e06bc.png";